<template>

    <section :class="{ dropped: navOpen, dark: darkMode }">
        <div>
            <a href="/">
                <img src="../../assets/Logo.svg" alt="">
            </a>
            <button @click="navOpen = !navOpen;">

                <img v-if="navOpen" src="../../assets/svg/closeMenu.svg" alt="">
                <img v-else src="../../assets/svg/openMenu.svg" alt="">

            </button>
        </div>
        <nav :class="{ dropped: navOpen }">
            <a href="#">
                <p>Home</p>
            </a>
            <a href="#about">
                <p>Sobre nosotros</p>
            </a>
            <a href="#servicios">
                <p>Servicios</p>
            </a>
            <a href="#proyectos">
                <p>Proyectos</p>
            </a>
            <a href="#clientes">
                <p>Clientes</p>
            </a>
            <a href="#contacto">
                <p>Contacto</p>
            </a>
        </nav>
    </section>

</template>

<script>
export default {
    props: {
        darkMode: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            navOpen: false,
        }
    },
}
</script>

<style scoped>
* {
    margin: 0;
    padding: 0;
}

*,
*::before,
*::after {
    box-sizing: border-box;
}

/* PC 1920 */
a {
    color: inherit;
    text-decoration: none;
}

section {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 3.802083333333333VW 5.885416666666667VW 5.885416666666667VW 4.84375VW;
    position: absolute;
    width: 100%;
    z-index: 9999999;

}

section>div {
    display: flex;
    flex-direction: row;
}

section>div img {
    width: 7.239583333333334VW;
    height: 3.7147395833333334VW;
}

.dark>div img {
    filter: invert(0.8);
}

section>div button {
    display: none;
}

nav {
    display: flex;
    flex-direction: row;
    gap: 1.8229166666666667VW;
}

.dark nav.dropped a p {
    color: #fff;
}


.dark nav a p {
    color: #282828;
}

nav a p {
    font-size: var(--M);
    font-family: "Montserrat", sans-serif;
    font-weight: 700;
    color: #fff;
    padding: 0.2vw 0.1vw;
    border-radius: 0.2vw;
    letter-spacing: 0.0390625VW;
}

nav a:hover p {
    background-color: #F1C422;
    color: #282828;
}

@media(max-width: 1440px) {
    section {
        padding: 5.069444444444445VW 6.388888888888888VW 7.916666666666666VW;

    }

    /* PC 1440 */
    nav {
        gap: 2.430555555555556VW;
    }

    section>div img {
        width: 9.652777777777779VW;
        height: 4.952986111111111VW;
    }
}

@media(max-width: 834px) {
    /* Tablet */

    .dark>div img {
        filter: invert(0);
    }

    section {
        padding: 4.796163069544365VW 10.551558752997602VW 2.3980815347721824VW;
        gap: 0vw;
        flex-direction: column;
        background-color: transparent;
        transition: all 300ms;

    }

    section.dropped {
        gap: 3vw;
        background-color: #282828;

    }

    section>div {
        width: 100%;
        justify-content: space-between;
        align-items: center;
    }

    section>div button {
        display: flex;
        border: none;
        background-color: transparent;
    }
    

    section>div button img {
        height: 6.175059952038369VW;
        width: 6.175059952038369VW;
    }

    nav {
        max-height: 0vw;
        overflow: clip;
        transition: all 300ms;
        gap: 4.1VW;
    }

    nav.dropped {
        padding: 1vw 0;
        max-height: 4vw;
    }
}

@media(max-width: 505px) {

    /* Movil */
    section {
        padding: 12.80193236714976VW 11.83574879227053VW;
        background: transparent;
    }
    section.dropped{
        background: #282828;

    }
    nav {
        flex-direction: column;
        width: 100%;
        transition: all 500ms;

    }

    nav.dropped {
        max-height: 115vw;
        padding: 20vw 0;

    }

    nav a p {
        padding: 2vw;
        font-size: var(--XL);
        text-align: right;
        border-radius: 1vw;
    }

    section>div button img {
        height: 13.17506VW;
        width: 13.17506VW;
    }

    section>div img {
        width: 25.120772946859905VW;
        height: 12.889855072463769VW;
    }
}
</style>